import { createBaseExportSchema } from '@app/modules/social-export/components/validation/useBaseExportSchema';
import { useMemo } from 'react';
import { IntlFormatters, useIntl } from 'react-intl';
import { z } from 'zod';

const FACEBOOK_TITLE_MAX_LENGTH = 255;

/** Builds the Zod schema for the Facebook publish form. */
export function createFacebookPublishSchema(t: IntlFormatters['$t']) {
  return createBaseExportSchema(t)
    .extend({
      title: z.string().trim().min(1).max(FACEBOOK_TITLE_MAX_LENGTH),
      description: z.string().trim().min(1),
      thumbType: z.enum(['DEFAULT', 'IMAGE_URL', 'VIDEO_FRAME']),
      thumbnailUrl: z.string().nullable().optional(),
      thumbOffsetMs: z.number().nullable().optional(),
      private: z.boolean(),
    })
    .refine(
      (data) => {
        if (data.thumbType === 'IMAGE_URL') {
          return !!data.thumbnailUrl;
        }
        return true;
      },
      { path: ['thumbnailUrl'] },
    );
}

export type FacebookPublishValues = z.infer<ReturnType<typeof createFacebookPublishSchema>>;

/** Zod schema for the Facebook publish form with translated validation messages. */
export function useFacebookPublishSchema() {
  const { $t } = useIntl();
  return useMemo(() => createFacebookPublishSchema($t), [$t]);
}
